<template>
  <div class="risk-item" :data-sprite-id="info.id">
    <div class="figure">
      <!-- <img
        v-if="thumbType === 'thumbnail'"
        :src="$handleAssetsUrl(info.thumbnailUrl)"
        alt=""
      />
      <div
        v-else
        class="vip-icon"
        :class="{
          video: spriteType === 'video',
          sound: spriteType === 'sound',
        }"
      ></div> -->
      <div v-html="dataHTML"></div>
    </div>
    <div class="control">
      <div class="locate" @click="locate">
        <i></i>
      </div>
      <div class="remove" @click="locate({ isDel: true })">
        <i></i>
      </div>
    </div>
  </div>
</template>

<script>
import RiskItem from './riskItem';
export default {
  mixins: [
    RiskItem
  ],
  props: {
    info: {
      type: Object,
      default () {
        return {
          fileType: ''
        }
      }
    }
  },
  data () {
    return {
      dataHTML: ''
    }
  },
  computed: {
    thumbType () {
      if (this.spriteType === 'video') {
        return this.spriteType;
      }
      if (this.info.thumbnailUrl && /\.(png|jpg)$/.test(this.info.thumbnailUrl)) {
        return 'thumbnail'
      }
      return this.spriteType;
    }
  },
  mounted () {
    this.loadSprite(this.info);
  },
  methods: {
    _makeid: function () {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },

    // id去重
    _id2unique: function (svg) {
      var _this = this;
      svg.find('[id]').each(function () {
        var new_id = _this._makeid();
        // var old_id = this.attr('id');
        // svg.select('g,style,mask,defs').each(function() {
        //     var reg = new RegExp(old_id, 'g');
        //     this.node.innerHTML = this.node.innerHTML.replace(reg, new_id);
        // });
        $(this).attr('id', new_id);
      });
    },

    async loadSprite (sprite) {
      sprite = sprite || this.info;
      let vipData = {};
      let spriteData, scenesData;
      switch (sprite.type) {
        case "bg":
          scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
          if (scenesData) {
            let t = scenesData.background.contentbg
              .find(".mask-blur")
              .prop("outerHTML");
            let $t = $(t).css({
              margin: 0,
              backgroundSize: "100% 100%",
            });
            vipData.html = $t[0].outerHTML;
          }
          break;

        case "scenes":
          scenesData = this.TOOL.getScenesIdData(sprite.id);
          let _data = await scenesData.getThumbnails();
          // $('<div>' + _data.dom + '</div>').children().eq(0)
          // let _dom = $('<div>' + _data.dom + '</div>');
          // _dom.css({position: 'relative'});
          // let _bg = _dom.children().eq(0);
          // _bg.css({ width: '100%', height: '100%' })
          // _bg.find('div').removeClass('mask-blur').css({ position: '', margin: 0, width: '100%', height: '100%', 'background-size': '100% 100%' })
          // vipData.html = _data.dom;// _dom.prop('outerHTML');
          // vipData.scale = 50 / _data.width;
          let b64 =
            "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMTIgMTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEyIDEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzQ3NDI2MTt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTExLjEzLDEySDAuODZDMC4zOCwxMiwwLDExLjYyLDAsMTEuMTRWNi4wMWgxMS45OXY1LjE0QzExLjk5LDExLjYyLDExLjYxLDEyLDExLjEzLDEyTDExLjEzLDEyeiBNOS40MiwzLjQ0CgkJaDEuNzFjMC40NywwLDAuODYsMC4zOCwwLjg2LDAuODZ2MC44Nkg4LjEzTDkuNDIsMy40NHogTTMuODQsNS4xNWwxLjI5LTEuNzFoMi44TDYuNjQsNS4xNUgzLjg0TDMuODQsNS4xNXogTTAsNS4xNVY0LjI5CgkJYzAtMC40NywwLjM4LTAuODYsMC44Ni0wLjg2aDIuOGwtMS4zLDEuNzJIMEwwLDUuMTV6IE0wLjMzLDIuNTlsMTEuMDktMi41N2MwLjI0LTAuMDcsMC40OCwwLjA3LDAuNTUsMC4zCgkJYzAuMDYsMC4yMy0wLjA3LDAuNDYtMC4zLDAuNTNoLTAuMDFMMC41NywzLjQyYy0wLjI0LDAuMDctMC40OC0wLjA3LTAuNTUtMC4zYy0wLjA2LTAuMjMsMC4wNy0wLjQ2LDAuMy0wLjUzCgkJQzAuMzIsMi41OSwwLjMyLDIuNTksMC4zMywyLjU5TDAuMzMsMi41OXoiLz4KPC9nPgo8L3N2Zz4K";
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="${b64}" style="height: 26px;width: auto;"/></div>`;
          break;

        case "ScenesSound":
          scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="/static/svg/copyright/copyright-music.svg" style="height: 26px;width: auto;"/></div>`;
          break;

        case "AllSound":
        case 'TOOLsound':
        case "sound":
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="/static/svg/copyright/copyright-music.svg" style="height: 26px;width: auto;"/></div>`;
          break;

        case "uploadVideoNUM":
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="/static/svg/copyright/copyright-membership.svg" style="height: 26px;width: auto;"/></div>`;
          break;

        case "Text":
        case "RichText":
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="/static/svg/copyright/copyright-font.svg" style="height: 26px;width: auto;"/></div>`;
          break;

        case "groupSprites":
          scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
          let groupData = scenesData.getGroupData(sprite.id).data;
          vipData.html =
            '<img src="https://resources.laihua.com/' +
            groupData.thumbnailUrl +
            '" style="height: 100%;width: auto;"/>';

        default: {
          spriteData = this.TOOL.findSpriteById(sprite.id);
          if (spriteData) {
            scenesData = this.TOOL.getScenesIdData(spriteData.scenesId);
            let scenesList =
              scenesData.fromJsonLoadingState === 2 &&
              scenesData.getSprites({ height: 50, width: 50 });
            let $t = spriteData.thumbnails || $("<div></div>");
            this._id2unique($t.find('svg'));
            let eleWidth = $t.width();
            let eleHeight = $t.height();
            let boxWidth = 40;
            let boxHeight = 40;
            let scale;
            if (eleHeight > eleWidth) {
              scale = boxHeight / eleHeight;
            } else {
              scale = boxWidth / eleWidth;
            }
            $t.css({
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: `translate(-50%, -50%) scale(${scale}, ${scale})`,
            });
            // $t.css('transform', '');
            vipData.html = $t && $t.prop("outerHTML");
          }
        }
      }

      this.dataHTML = vipData.html;
      return vipData;
    },
  }
}
</script>

<style lang="scss" scoped>
.risk-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 146px;
  height: 66px;
  background: #ffffff;
  border-radius: 4px;
  padding: 0 10px;
  .locate > i:hover {
    background-image: url(../../../assets/risk/locate-active.svg);
  }
  .remove > i:hover {
    background-image: url(../../../assets/risk/remove-active.svg);
  }
}
.figure {
  position: relative;
  width: 70px;
  height: 38px;
  background: #fafaff;
  // border: 1px solid #707070;
  border-radius: 4px;
  overflow: hidden;
  & > * {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    margin: auto;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
.control {
  display: flex;
  align-items: center;
  & .locate {
    margin-left: 10px;
    margin-right: 10px;
    cursor: pointer;
  }
  & .remove {
    cursor: pointer;
  }
}
.locate > i {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url(../../../assets/risk/locate.svg);
}
.remove > i {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url(../../../assets/risk/remove.svg);
}
.vip-icon {
  width: 80%;
  height: 80%;
  background: no-repeat;
  background-image: url(../../../../static/svg/copyright/copyright-membership.svg);
  background-position: center center;

  &.video {
    background-image: url(../../../../static/svg/path-play-active.svg);
  }
  &.sound {
    background-image: url(../../../../static/svg/vip-sprites-music.svg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/riskDrop/riskItemLite.vue